export const SET_EVENT_DAY = 'SET_EVENT_DAY';
export const SET_LAST_VISITED_MONTH_VALUE = 'SET_LAST_VISITED_MONTH_VALUE';
export const SET_WHOLE_MONTH_EVENT_OBJECT = 'SET_WHOLE_MONTH_EVENT_OBJECT';
